import { useEffect, useRef, useState } from 'react';

/**
 * Native <dialog> with a textarea — replaces browser prompt(). Cancel/Escape
 * aborts (onSubmit never fires); Submit sends the (possibly empty) text.
 */
export function PromptDialog({
  open,
  title,
  label,
  placeholder,
  submitLabel,
  onSubmit,
  onClose,
}: {
  open: boolean;
  title: string;
  label: string;
  placeholder?: string;
  submitLabel: string;
  onSubmit: (value: string) => void;
  onClose: () => void;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  const [value, setValue] = useState('');

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (open && !el.open) {
      setValue('');
      el.showModal();
    }
    if (!open && el.open) el.close();
  }, [open]);

  return (
    <dialog
      ref={ref}
      onClose={() => {
        if (ref.current?.returnValue === 'submit') onSubmit(value);
        if (ref.current) ref.current.returnValue = '';
        onClose();
      }}
      onClick={(e) => {
        if (e.target === ref.current) ref.current?.close();
      }}
    >
      <form method="dialog">
        <h2>{title}</h2>
        <div className="field" style={{ marginBottom: 16 }}>
          <label htmlFor="prompt-dialog-input">{label}</label>
          <textarea
            id="prompt-dialog-input"
            rows={3}
            placeholder={placeholder}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            autoFocus
          />
        </div>
        <div className="dialog-actions">
          <button value="">Cancel</button>
          <button value="submit" className="primary">
            {submitLabel}
          </button>
        </div>
      </form>
    </dialog>
  );
}
